import request from '@/utils/request'

const currentPromotion = () => {
  return request({
    url: `/api/promotion/current`,
    method: 'get'
  })
}

const findPromotion = code => {
  return request({
    url: `/api/promotion/find/${encodeURIComponent(code)}`,
    method: 'get'
  })
}

const activatePromotion = code => {
  return request({
    url: `/api/promotion/activate/${encodeURIComponent(code)}`,
    method: 'get'
  })
}

export default {
  currentPromotion,
  findPromotion,
  activatePromotion
}
